import QueryParameters from 'helpers/query-parameters.js';
import ExceptionService from 'core-services/exceptions/exception-service.js';
// Constants
import { ANDROID_IDENTIFIER, IOS_IDENTIFIER } from 'mobile/mobile-constants';
const FILENAME = 'mobile-service.ts';
/**
 * Logs and Triggers an error.
 * @param {String} type
 * @param {String} msg
 * @private
 */
const throwError = (msg, type) => {
    ExceptionService.handle('error', {
        filename: FILENAME,
        message: msg,
        data: {},
        sendToSentry: true,
    });
    throw {
        type,
        message: msg,
    };
};
/**
 * Indicates whether or not the user is using
 * authentication via the mobile flow.
 * Matches against ?auth-type=ios|android
 * @return boolean
 */
const isAuthenticationMobileFlow = () => {
    const authType = QueryParameters.getMobileAuthParameter();
    return [ANDROID_IDENTIFIER, IOS_IDENTIFIER].includes(authType);
};
/**
 * Invokes a given Android Namespace callback.
 * The Android namespace is defined by the Android app
 * when a web-view is launched. It's defined onto the window.
 * @param {Object} AndroidNameSpace - window.[AndroidNameSpace]
 * @param {String} callbackName - function name
 * @param {Object} params - callback arguments, optional
 * @public
 */
const invokeAndroidNamespace = (AndroidNameSpace, callbackName, params) => {
    if (!AndroidNameSpace) {
        return throwError('invokeAndroidNamespace() Android Namespace is missing', 'MOBILE_ANDROID_NAMESPACE_MISSING');
    }
    try {
        const androidParams = JSON.stringify(params);
        AndroidNameSpace[callbackName](androidParams);
    }
    catch (e) {
        throwError(e, 'MOBILE_ANDROID_CALLBACK_FAILURE');
    }
};
/**
 * Function used in the Mobile authentication flow.
 * After the authentication is success, we invoke a Mobile callback to
 * trigger the app to pass back the nonce token or a given location.
 * Documentation: https://busuucom.atlassian.net/wiki/spaces/FRON/pages/5238849622/Login+via+Web+from+Mobile+Front-end
 * @param {String} nonce
 * @param {String} accessType
 * @param {String} backendRedirection
 * @public
 */
const callbackAppsOnAuthFlow = (params) => {
    const { nonce = null, accessType = null, backendRedirection = null } = params;
    const getiOSParams = () => {
        let str = '';
        if (nonce) {
            str += `nonce=${nonce}`;
        }
        else if (backendRedirection) {
            str += `location=${encodeURIComponent(backendRedirection)}`;
        }
        str += `&access_type=${accessType}`;
        return str;
    };
    if (!nonce && !backendRedirection) {
        throwError('callbackAppsOnAuthFlow() Mandatory param is missing.', 'MOBILE_PARAMS_MISSING');
    }
    const authType = QueryParameters.getMobileAuthParameter();
    const AndroidParams = {
        access_type: accessType,
    };
    switch (authType) {
        case IOS_IDENTIFIER:
            window.location.href = `busuulogin://auth?${getiOSParams()}`;
            break;
        case ANDROID_IDENTIFIER:
            if (nonce) {
                invokeAndroidNamespace(window.Android, 'onNonceAvailable', Object.assign(Object.assign({}, AndroidParams), { nonce }));
            }
            else {
                invokeAndroidNamespace(window.Android, 'onLocationAvailable', Object.assign(Object.assign({}, AndroidParams), { location: backendRedirection }));
            }
            break;
        default:
            throwError('callbackAppsOnAuthFlow() authType not found.', 'MOBILE_AUTH_TYPE_MISSING');
    }
};
const MobileService = {
    isAuthenticationMobileFlow,
    callbackAppsOnAuthFlow,
    invokeAndroidNamespace,
};
export default MobileService;
